import { Button, Modal } from 'react-bootstrap';
import { BookingRequestRead } from '../../../api';
import { bookingRequestsQueryKeys } from '../../query-keys-factories/booking-requests';
import { userQueryKeys } from '../../query-keys-factories/user';
import { BookingRequestDialogFooter } from './BookingRequestDialogFooter';
import { CancelationButton } from './CancelationButton';

interface DialogFooterProps {
  bookings: BookingRequestRead['bookings'];
  totalValue: number;
  overallBooking: number;
  totalHours: number;
  userIsProvider: boolean;
  allowCancel: boolean;
  bookingRequestId: string;
  refetch: () => void;
  queryClient: any;
  onUpdateStatus?: () => void;
  externalOnHide?: () => void;
  allBookingsInPast: boolean;
  allowUpdates: boolean;
  submitAction?: string;
  handleSubmit: any;
  onSubmit: any;
  handleSubmitClick: () => void;
  mutationBookingUpdate: any;
  isSubmitEnabled: boolean;
  showFullDecline: boolean;
}

export const DialogFooter = ({
  bookings,
  totalValue,
  overallBooking,
  totalHours,
  userIsProvider,
  allowCancel,
  bookingRequestId,
  refetch,
  queryClient,
  onUpdateStatus,
  externalOnHide,
  allBookingsInPast,
  allowUpdates,
  submitAction,
  handleSubmit,
  onSubmit,
  handleSubmitClick,
  mutationBookingUpdate,
  isSubmitEnabled,
  showFullDecline,
}: DialogFooterProps) => {
  return (
    <Modal.Footer className="d-block bg-neutral-200 px-1">
      <BookingRequestDialogFooter
        totalValue={totalValue}
        overallBooking={overallBooking}
        totalHours={totalHours}
      >
        {(allowCancel || submitAction) && (
          <>
            {!userIsProvider && allowCancel && (
              <CancelationButton
                size="lg"
                className="btn btn-danger"
                bookingRequestId={bookingRequestId}
                onHidden={() => {
                  refetch();
                  queryClient.invalidateQueries(bookingRequestsQueryKeys.allLists());
                  queryClient.invalidateQueries(bookingRequestsQueryKeys.allDetails());
                  queryClient.invalidateQueries(userQueryKeys.notifications());
                  onUpdateStatus && onUpdateStatus();
                  externalOnHide?.();
                }}
              />
            )}
            {!allBookingsInPast && allowUpdates && submitAction && (
              <Button
                size="lg"
                type="submit"
                className="btn btn-primary"
                onClick={(e) => {
                  handleSubmit(onSubmit)(e);
                  handleSubmitClick();
                }}
                disabled={
                  mutationBookingUpdate.isLoading ||
                  !isSubmitEnabled ||
                  (userIsProvider ? false : showFullDecline)
                }
              >
                {submitAction}
              </Button>
            )}
          </>
        )}
      </BookingRequestDialogFooter>
    </Modal.Footer>
  );
};
